module.exports = __webpack_public_path__ + "static/media/interiorImage1-min.bffe9c73.jpg";